const observeUrlChange = () => {
  let oldHref = document.location.href;
  const body = document.querySelector("body");
  const observer = new MutationObserver((mutations) => {
    if (oldHref !== document.location.href) {
      oldHref = document.location.href;
      destroyBehaviors();
      initBehaviors();
    }
  });
  observer.observe(body, { childList: true, subtree: true });
};

window.addEventListener("DOMContentLoaded", () => {
  initBehaviors();
  observeUrlChange();
});

class Base {
  constructor(behaviorName, element) {
    this.behaviorName = behaviorName;
    this.element = element;
    this.refs = {};
    this.baseInit();
  }

  baseInit() {
    this.populateRefsObject();
  }

  populateRefsObject() {
    const attribute = `data-ref-${this.behaviorName}`;
    this.element.querySelectorAll(`[${attribute}]`).forEach((refElement) => {
      const attributeValue = dashToCamel(refElement.getAttribute(attribute));
      this.refs[attributeValue] = refElement;
    });
  }

  cleanup() {
    // Override this function in your classes as required
  }
}

const initBehaviors = (context) => {
  let { behaviorInstances } = window.alfies;
  const attribute = "data-behavior";
  let elements = [];

  if (context === undefined) {
    context = document.body;
  }

  elements = Array.prototype.slice.call(
    context.querySelectorAll(`[${attribute}]`)
  );

  if (context.hasAttribute(attribute)) {
    elements.unshift(context);
  }

  elements.forEach((element) => {
    const contextBehaviors = element.getAttribute(attribute).split(" ");

    contextBehaviors.forEach((behavior) => {
      const behaviorClassName = capitalize(dashToCamel(behavior));
      const instanceId = generateId(5);
      const instanceAttribute = "data-behavior-instance";
      const instanceAttributeCurrentValue =
        element.getAttribute(instanceAttribute) || "";

      if (!instanceAttributeCurrentValue.includes(behavior)) {
        let instanceAttributeNewValue = instanceAttributeCurrentValue
          ? instanceAttributeCurrentValue + " "
          : "";
        instanceAttributeNewValue += `${behavior}_${instanceId}`;

        element.setAttribute(instanceAttribute, instanceAttributeNewValue);

        if (behaviorClasses[behaviorClassName]) {
          behaviorInstances[`${behavior}_${instanceId}`] = new behaviorClasses[
            behaviorClassName
          ](behavior, element);
        }
      }
    });
  });
};

const destroyBehaviors = (context) => {
  const { behaviorInstances } = window.alfies;
  const attribute = "data-behavior-instance";

  let elements = [];

  if (context === undefined) {
    context = document.body;
  }

  elements = Array.prototype.slice.call(
    context.querySelectorAll(`[${attribute}]`)
  );

  if (context.hasAttribute(attribute)) {
    elements.unshift(context);
  }

  elements.forEach((element) => {
    const contextBehaviorInstances = element.getAttribute(attribute).split(" ");
    element.removeAttribute(attribute);

    contextBehaviorInstances.forEach((behaviorInstance) => {
      if (behaviorInstances[behaviorInstance]) {
        behaviorInstances[behaviorInstance].cleanup();
        behaviorInstances[behaviorInstance] = null;
        delete behaviorInstances[behaviorInstance];
      }
    });
  });
};

const cleanupBehaviors = () => {
  const { behaviorInstances } = window.alfies;
  const attribute = "data-behavior-instance";

  let documentBehaviorInstances = [];

  document.body.querySelectorAll(`[${attribute}]`).forEach((element) => {
    const elementBehaviorInstances = element.getAttribute(attribute).split(" ");

    elementBehaviorInstances.forEach((behaviorInstance) => {
      documentBehaviorInstances.push(behaviorInstance);
    });
  });

  Object.keys(behaviorInstances).forEach((instance) => {
    if (documentBehaviorInstances.indexOf(instance) === -1) {
      if (behaviorInstances[instance]) {
        behaviorInstances[instance].cleanup();
        behaviorInstances[instance] = null;
        delete behaviorInstances[instance];
      }
    }
  });
};

const generateId = (length) => {
  let id = "";
  let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    id += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return id;
};

const camelToDash = (str) => {
  return str.replace(/\W+/g, "-").replace(/([a-z\d])([A-Z])/g, "$1-$2");
};

const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const dashToCamel = (str) => {
  return str.replace(/\W+(.)/g, (x, chr) => {
    return chr.toUpperCase();
  });
};

const handleize = (str) => {
  return str.toLowerCase().replace(/ /g, "-").replace(/&/g, "and");
};

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
}

class FilterInput extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    const { inputField, buttonSearch, buttonClose } = this.refs;
    inputField.addEventListener("change", (evt) => {
      const key = evt.target.value.toLowerCase().trim();
      this.filterCollection(key, this.element, buttonSearch, buttonClose);
    });
    inputField.addEventListener("input", (evt) => {
      const key = evt.target.value.toLowerCase().trim();
      this.filterCollection(key, this.element, buttonSearch, buttonClose);
    });
    buttonClose.addEventListener("click", (evt) => {
      inputField.value = "";
      this.filterCollection("", this.element, buttonSearch, buttonClose);
    });
  }

  filterCollection(key, element, buttonSearch, buttonClose) {
    if (key.length >= 1) {
      buttonSearch.classList.add("hide");
      buttonClose.classList.remove("hide");
    } else {
      buttonSearch.classList.remove("hide");
      buttonClose.classList.add("hide");
    }
    const productGrid = document.getElementsByClassName("product-grid")[0];
    const cards = productGrid.getElementsByClassName("product-item");
    let total = 0;
    for (let card of cards) {
      if (card.dataset.title.toLowerCase().includes(key)) {
        card.classList.remove("filter-out");
        total++;
      } else {
        card.classList.add("filter-out");
      }
    }
    const oneProduct = element.dataset.oneProduct;
    const otherProduct = element.dataset.otherProduct;
    const label = document.getElementsByClassName(
      "collection-utility-bar__count-text"
    )[0];
    let result = otherProduct.replace("{{ count }}", total);
    if (total == 1) {
      result = oneProduct.replace("{{ count }}", total);
    }
    label.innerHTML = result;
  }

  cleanup() {
    const { inputField } = this.refs;
    if (inputField) {
      inputField.removeEventListener("change", () => {});
      inputField.removeEventListener("input", () => {});
    }
  }
}

class ProductCard extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);

    const isMobile = navigator.userAgentData.mobile;
    if (!isMobile) {
      this.element.classList.add("desktop");
      this.init();
    }
  }

  init() {
    const { image, glow, preloader } = this.refs;

    this.element.addEventListener("mousemove", (evt) => {
      this.rotateMouse(evt, this.element, image, glow);
    });

    this.element.addEventListener("mouseleave", (evt) => {
      this.element.removeEventListener("mousemove", () => {});
      image.style.top = "0px";
      image.style.transform = "";
      image.style.background = "";
      glow.style.opacity = 0;
    });

  }

  rotateMouse(evt, element, image, glow) {
    var w = window.innerWidth;
    if (w < 990) return;
    const bounds = element.getBoundingClientRect();
    const mouseX = evt.clientX;
    const mouseY = evt.clientY;
    const leftX = mouseX - bounds.x;
    const topY = mouseY - bounds.y;
    const center = {
      x: leftX - bounds.width / 2,
      y: topY - bounds.height / 2,
    };
    const distance = Math.sqrt(center.x ** 2 + center.y ** 2);

    image.style.top = "-20px";
    image.style.transform = `
    scale3d(1.2, 1.2, 1.2)
    rotate3d(
      ${center.y / 100},
      ${-center.x / 100},
      0,
      ${Math.log(distance) * 3}deg
    )`;

    const glowType = element.dataset.glowType;
    if (glowType == "foil") {
      glow.style.backgroundImage = `
      linear-gradient(
        125deg,
        #0000000f 0%,
        #FFFFFF55 ${center.x * 2 + bounds.width / 2}px,
        #0000000f 100%
      )`;
    } else {
      glow.style.backgroundImage = `
    radial-gradient(
      circle at
      ${center.x * 2 + bounds.width / 2}px
      ${center.y * 2 + bounds.height / 2}px,
      #FFFFFF55,
      #0000000F
    )`;
    }
    glow.style.opacity = 1;
  }

  cleanup() {
    this.element.removeEventListener("mouseleave", () => {});
    this.element.removeEventListener("mousemove", () => {});
  }
}

const behaviorClasses = { FilterInput, ProductCard };
